var map = {
	"./de.json": 101,
	"./en.json": 102,
	"./fr.json": 103,
	"./ja.json": 104,
	"./ko.json": 105,
	"./pt-br.json": 106,
	"./ru.json": 107,
	"./zh.json": 108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;